import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

const getItems = ({ commit }, { page = 'accounts', params = {} }) => {
  commit(types.TOGGLE_LOADING)

  fetch(page, { params })
    .then((response) => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_ITEMS, data.member)
      commit(types.SET_VIEW, data.view)
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_ERROR, e.message)
    })
}

export const getSelectItems = (
  { commit },
  { page = 'accounts', params = { properties: ['@id', 'name'] } } = {}
) => {
  commit(types.TOGGLE_LOADING)

  fetch(page, { params })
    .then((response) => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_SELECT_ITEMS, data.member)
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_ERROR, e.message)
    })
}

export default getItems
